import { Modal, ModalContent, ModalTrigger } from 'src/shared/ui/components/Modal';

import { FrequentPassageRequest } from '@legacy-types';

import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';

import { RejectFrequentPassageRequestButtonForm } from './RejectFrequentPassageRequestButtonForm';

type RejectFrequentPassageRequestButtonProps = {
  frequentPassageRequest: FrequentPassageRequest;
  onReject?: (frequentPassageRequest: FrequentPassageRequest) => void;
};

export function RejectFrequentPassageRequestButton({
  frequentPassageRequest,
  onReject,
}: RejectFrequentPassageRequestButtonProps) {
  return (
    <Modal>
      <ModalTrigger asChild>
        <Button variant="destructive" size="sm" disabled={!frequentPassageRequest.canReject}>
          <Icon icon="close" /> Reject
        </Button>
      </ModalTrigger>
      <ModalContent title="Reject Frequent Passage Request">
        {({ close }) => (
          <RejectFrequentPassageRequestButtonForm
            frequentPassageRequest={frequentPassageRequest}
            onSave={(frequentPassageRequest: FrequentPassageRequest) => {
              onReject?.(frequentPassageRequest);
              close();
            }}
            onCancel={close}
          />
        )}
      </ModalContent>
    </Modal>
  );
}
